export interface ISlackChannel {
  id?: number
  external_id: string
}
export interface ISalesforceField {
  name: string
  label: string
  bookmark_id?: number
}

export interface IBookmark {
  id?: number
  hex_color: string
  label: string
  created_at?: string
  updated_at?: string
  sort_order?: number
  slack_channel?: ISlackChannel
  deleted?: boolean
  action_item?: boolean
  bookmark?: boolean
  question?: boolean
  screen_share?: boolean
  immutable?: boolean
  highlight?: boolean
  default_highlight?: boolean
  hidden?: boolean
}

export function isAnnotation(bookmark: IBookmark): boolean {
  return bookmark.highlight || bookmark.bookmark
}

export function isHighlight(bookmark: IBookmark): boolean {
  return bookmark.highlight
}

export function isImmutable(bookmark: IBookmark): boolean {
  return bookmark.immutable
}

export function isActionItem(bookmark: IBookmark): boolean {
  return bookmark.action_item
}

export function isBookmark(bookmark: IBookmark): boolean {
  return bookmark.bookmark
}

export function isQuestion(bookmark: IBookmark): boolean {
  return bookmark.question
}

export function isScreenShare(bookmark: IBookmark): boolean {
  return bookmark.screen_share
}

export interface IHighlightReel {
  id: number
  bookmark_id: number
  length: number
  duration_seconds: number
  share_url?: string
  activate_share_url?: string
}
